export enum TransactionStatus {
    Pending = 0,
    Submitted = 1,
    Approved = 2,
    Declined = 3,
    Funded = 4,
    Settled = 5,
    Returned = 6,
    ReturnRetry = 7,
    PostSettleReturn = 8,
    Refunded = 9,
    Voided = 10,
    Cancelled = 11,
    Failed = 12,
    TimedOut = 13,
    NocReceived = 14,
    Unsettled = 15,
    RefundFailed = 16,
    PartiallyRefunded = 17,
    PartialRefundFailed = 18,
}

export const TransactionStatusLabels: Record<TransactionStatus, string> = {
    [TransactionStatus.Pending]: 'Pending',
    [TransactionStatus.Submitted]: 'Submitted',
    [TransactionStatus.Approved]: 'Approved',
    [TransactionStatus.Declined]: 'Declined',
    [TransactionStatus.Funded]: 'Funded',
    [TransactionStatus.Settled]: 'Settled',
    [TransactionStatus.Returned]: 'Returned',
    [TransactionStatus.ReturnRetry]: 'Return Retry',
    [TransactionStatus.PostSettleReturn]: 'Post Settle Return',
    [TransactionStatus.Refunded]: 'Refunded',
    [TransactionStatus.Voided]: 'Voided',
    [TransactionStatus.Cancelled]: 'Cancelled',
    [TransactionStatus.Failed]: 'Failed',
    [TransactionStatus.TimedOut]: 'Timed Out',
    [TransactionStatus.NocReceived]: 'NOC Received',
    [TransactionStatus.Unsettled]: 'Unsettled',
    [TransactionStatus.RefundFailed]: 'Refund Failed',
    [TransactionStatus.PartiallyRefunded]: 'Partially Refunded',
    [TransactionStatus.PartialRefundFailed]: 'Partial Refund Failed',
}

export interface StatusConfig {
    label: string
    cssClass: string
}

export const StatusStyleMap: Record<TransactionStatus, StatusConfig> = {
    [TransactionStatus.Pending]: { label: 'Pending', cssClass: 'status-badge--pending' },
    [TransactionStatus.Submitted]: { label: 'Submitted', cssClass: 'status-badge--submitted' },
    [TransactionStatus.Approved]: { label: 'Approved', cssClass: 'status-badge--approved' },
    [TransactionStatus.Declined]: { label: 'Declined', cssClass: 'status-badge--declined' },
    [TransactionStatus.Funded]: { label: 'Funded', cssClass: 'status-badge--funded' },
    [TransactionStatus.Settled]: { label: 'Settled', cssClass: 'status-badge--settled' },
    [TransactionStatus.Returned]: { label: 'Returned', cssClass: 'status-badge--returned' },
    [TransactionStatus.ReturnRetry]: { label: 'Return Retry', cssClass: 'status-badge--return-retry' },
    [TransactionStatus.PostSettleReturn]: { label: 'Post Settle Return', cssClass: 'status-badge--post-settle-return' },
    [TransactionStatus.Refunded]: { label: 'Refunded', cssClass: 'status-badge--refunded' },
    [TransactionStatus.Voided]: { label: 'Voided', cssClass: 'status-badge--voided' },
    [TransactionStatus.Cancelled]: { label: 'Cancelled', cssClass: 'status-badge--cancelled' },
    [TransactionStatus.Failed]: { label: 'Failed', cssClass: 'status-badge--failed' },
    [TransactionStatus.TimedOut]: { label: 'Timed Out', cssClass: 'status-badge--timed-out' },
    [TransactionStatus.NocReceived]: { label: 'NOC Received', cssClass: 'status-badge--noc-received' },
    [TransactionStatus.Unsettled]: { label: 'Unsettled', cssClass: 'status-badge--unsettled' },
    [TransactionStatus.RefundFailed]: { label: 'Refund Failed', cssClass: 'status-badge--refund-failed' },
    [TransactionStatus.PartiallyRefunded]: { label: 'Partially Refunded', cssClass: 'status-badge--partially-refunded' },
    [TransactionStatus.PartialRefundFailed]: { label: 'Partial Refund Failed', cssClass: 'status-badge--partial-refund-failed' },
}

export enum NotificationStatus {
    Delivered = 0,
    Failed = 1,
    Pending = 2,
}

export const NotificationStatusLabels: Record<NotificationStatus, string> = {
    [NotificationStatus.Delivered]: 'Delivered',
    [NotificationStatus.Failed]: 'Failed',
    [NotificationStatus.Pending]: 'Pending',
}

export interface NotificationStatusConfig {
    label: string
    cssClass: string
}

export const NotificationStatusStyleMap: Record<NotificationStatus, NotificationStatusConfig> = {
    [NotificationStatus.Delivered]: { label: 'Delivered', cssClass: 'status-badge--delivered' },
    [NotificationStatus.Failed]: { label: 'Failed', cssClass: 'status-badge--failed' },
    [NotificationStatus.Pending]: { label: 'Pending', cssClass: 'status-badge--pending' },
}
